import ActivityIntellectual from "./ActivityIntellectual";

export default ActivityIntellectual;